<template>
    <div>
        <div id="vrm-banners" ref="banners" class="vrm-banners">
            <div
                v-if="globalBanner.showGlobalMessage && !globalMessageDismissed"
                id="global-message-bar"
                class="vrm-sticky-bar error"
                :class="{ info: globalBanner.globalMessageType === 'info' }"
            >
                <div class="alarm-content">
                    <p v-html="globalBanner.globalMessage"></p>
                </div>
                <div class="alarm-cross" @click="dismissGlobalMessage()">
                    <span class="sg-vrm-icon_055_cross-16px"></span>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped lang="scss"></style>
<script>
import { Vue, Component } from 'vue-property-decorator';
import { AngularDirective, ngInject } from '@/vue/decorators/angular-interop';
import VrmTwoFaNonAdminBanner from './VrmTwoFaNonAdminBanner.vue';
@Component({
    components: { VrmTwoFaNonAdminBanner },
})
@AngularDirective('vrm-global-message')
export default class VrmGlobalMessage extends Vue {
    globalBanner = {};
    globalMessageDismissed = false;
    @ngInject()
    $rootScope;

    created() {
        this.globalBanner = window.__banner || {};
        this.globalMessageDismissed = !!sessionStorage.getItem('globalMessageDismissed');
    }

    resetMessage() {
        this.globalBanner = window.__banner;
        this.globalMessageDismissed = false;
        sessionStorage.setItem('globalMessageDismissed', '');
    }

    dismissGlobalMessage() {
        this.globalMessageDismissed = true;
        sessionStorage.setItem('globalMessageDismissed', 'true');
    }
}
</script>
